// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "@components";

type OwnProps = $Exact<{
  onToggle: Function,
  onSubmit: Function,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class ScheduledReportsWarningModal extends React.Component<Props> {
  render() {
    return (
      <Modal>
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onToggle}>
          {this.props.t("SCHEDULED_REPORTS")}
        </ModalHeader>
        <ModalBody>
          <h5 className={"text-orange font-weight-bold"}>
            {this.props.t("ENABLE_SCHEDULED_REPORTS_WARNING")}
          </h5>
          <p>{this.props.t("ENABLE_SCHEDULED_REPORTS_WARNING_TEXT_1")}</p>
          <p>{this.props.t("ENABLE_SCHEDULED_REPORTS_WARNING_TEXT_2")}</p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onToggle}>
            {this.props.t("CANCEL")}
          </Button>
          <Button disabled={false} onClick={this.props.onSubmit}>
            {this.props.t("ENABLE_SCHEDULED_REPORTS_BUTTON")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(ScheduledReportsWarningModal);
